import { constants, sentry, getGqlQuery } from 'common/helpers'
import request from 'sb-request'


export const modifyItems = (queue) => {
  let { items, recommendationTag } = queue || {}

  // TODO OMG backend sends "null" sometimes....
  if (!items) {
    items = []
  }

  const newItems = items.map((item) => {
    const statuses = [ 'skipped', 'locked', 'shipped', 'paused' ]

    statuses.forEach((value) => {
      item[value] = item.status.some((status) => status === constants.queueItemStatuses[value])
    })

    if (!item.status) {
      item.status = []
    }

    if (!item.products) {
      item.products = []
    }

    item.disabled = (
      !item.status.some((status) => [ 'empty', 'product', 'free' ].includes(status))
      && (
        item.skipped
        || item.locked
        || item.shipped
      )
    )

    item.empty = item.products.length === 0

    item.products = item.status.map((status, index) => {
      let product = item.products[index] || {}

      const isEmpty = !product.id
      const isUnavailable = status === constants.queueItemStatuses.unavailable
      const isFree = (
        status === constants.queueItemStatuses.free
        || status === constants.queueItemStatuses.redeemed
      )
      // it's for correct work of moveProduct / removeProduct methods
      const disabled = [ 'skipped', 'locked', 'shipped'].includes(status) || isEmpty

      const data = {
        ...product,
        status,
        isEmpty,
        isFree,
        isUnavailable,
        disabled,
      }

      // SCNT-5156: abTest queueEmptyPlusCell to show plus in all empty cells
      // not locked for adding so check the month is active - !item.disabled
      if (isEmpty && !item.disabled) {
        data.isAvailableForAdd = true
      }

      return data
    })

    if (item.products.some((product) => !product)) {
      sentry.captureException('Missed Queue Product', {
        extra: {
          responseQueue: queue,
          modifiedProducts: item.products,
        },
      })

      item.products = item.products.filter((product) => product)
    }

    return item
  })

  return {
    recommendationTag,
    items: newItems,
  }
}

const fetch = ({ limit } = {}) => {
  const queryParams = getGqlQuery('queue', {
    limit,
  })

  return request.post('graphql?name=queue', {
    body: {
      query: `{
        ${queryParams} {
          items {
            year
            month
            status: statusName
            tracking {
              id
              trackingNumber
              trackingUrl
              shipmentDate
              status
            }
            products {
              id
              name
              brand
              image
              index
              upchargePrice
              isLimitedEdition
              queueItemId
              typeGroup
            }
          }
          recommendationTag {
            id
            name
            image
            voteCount
          }
        }
      }`,
    },
    modifyResult: ({ queue }) => modifyItems(queue),
  })
}


export default {
  fetch,
  modifyItems,
}
